import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, catchError, isObservable, map, of, switchMap } from 'rxjs';
import { MenuService } from '../services/Menu/menu.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private menuService: MenuService,
  ) { }

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    // A tab stopped for showing another user needs an explicit sign-in; it does not resume as
    // whoever is signed in on the shared session now.
    if (this.authService.isTabSessionInvalidated()) {
      return this.router.createUrlTree(['/login']);
    }

    // const token = this.authService.getAccessToken();
    const loginParseData = this.authService.getParsedLoginData();

    // if (!token) {
    //   return this.router.createUrlTree(['/login']);
    // }

    if (loginParseData) {
      const userId = loginParseData.user?._id;
      if (userId && !this.authService.restoreTabSession(String(userId))) {
        return this.router.createUrlTree(['/login']);
      }
      return this.resolveUserRoute(loginParseData);
    }

    // if (!this.authService.getRefreshToken()) {
    //   return this.router.createUrlTree(['/login']);
    // }

    return this.authService.restoreLoginDataFromProfile().pipe(
      switchMap((restoredLoginData) => this.toGuardResult$(this.resolveUserRoute(restoredLoginData))),
      catchError((error) => {
        console.error('Unable to restore login data', error);
        this.authService.forceLogout('Unable to restore login session');
        return of(this.router.createUrlTree(['/login']));
      })
    );
  }

  private resolveUserRoute(loginParseData: any): boolean | UrlTree | Observable<boolean | UrlTree> {
    const statusdata = this.authService.getProfileStatus();

    const user = loginParseData.user;

    if (!user) {
      return this.router.createUrlTree(['/login']);
    }

    // Marketplace user logic
    if (user.userTypeSlug === 'marketplace') {


      if (statusdata === 'approved' || statusdata === 'under_verification' || statusdata === 'resubmitted') {

        return true;
      } else if (statusdata === 'pending') {
        return this.router.createUrlTree(['/upload-documents']);
      } else if (statusdata === 'rejected') {
        return this.router.createUrlTree(['/re-upload-documents']);
      } else {
        return this.router.createUrlTree(['/upload-documents']);
      }
    }

    // Non-marketplace user logic: check onboarding_status
    if (!user.onboarding_status) {
      return this.router.createUrlTree(['/onboarding']);
    }

    if (user.userTypeSlug === 'employee') {
      return this.menuService.ensureEmployeeAccessLoaded().pipe(
        map(() => true),
        catchError((error) => {
          console.error('Unable to load employee access', error);
          return of(this.router.createUrlTree(['/access-pending']));
        }),
      );
    }

    // If onboarding completed, allow access
    return true;
  }

  private toGuardResult$(result: boolean | UrlTree | Observable<boolean | UrlTree>): Observable<boolean | UrlTree> {
    return isObservable(result) ? result : of(result);
  }
}
